import React from 'react'
import { LoadingContent } from '@ztechapps/webui.util'

export const LoadingShippingRates = () => {
  return (
    <LoadingContent
      message="Computing shipping rates."
      subMessage="Please wait while we are computing your shipping rates based on the shipping address."
    />
  )
}
